var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 40 40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.9 11.7c-.1-2.1-.4-3.6-.9-4.9s-1.2-2.4-2.3-3.5-2.3-1.8-3.6-2.3-2.7-.8-4.9-.9c-2.1-.1-2.8-.1-8.2-.1s-6.1 0-8.2.1c-2.2.1-3.6.4-4.9.9s-2.4 1.2-3.5 2.4-1.8 2.2-2.4 3.5c-.5 1.3-.8 2.7-.9 4.9-.1 2.1-.1 2.8-.1 8.2s0 6.1.1 8.2.4 3.6.9 4.9 1.2 2.4 2.3 3.5 2.2 1.8 3.5 2.3 2.7.8 4.9.9c2.2.2 2.9.2 8.3.2s6.1 0 8.2-.1 3.6-.4 4.9-.9 2.4-1.2 3.5-2.3 1.8-2.2 2.3-3.5.8-2.7.9-4.9c.2-2.2.2-2.9.2-8.3s0-6.1-.1-8.3zm-19.9 18.6c-5.7 0-10.3-4.6-10.3-10.3s4.6-10.3 10.3-10.3 10.3 4.6 10.3 10.3-4.6 10.3-10.3 10.3zm10.7-18.6c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4 2.4 1.1 2.4 2.4-1.1 2.4-2.4 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.7 20c0 3.7-3 6.7-6.7 6.7s-6.7-3-6.7-6.7 3-6.7 6.7-6.7 6.7 3 6.7 6.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1a28f25d1171e7045e8870e102d55f58.svg";
export { ForwardRef as ReactComponent };